<template>
    <v-app>
        <md-snackbar :md-position="snackbar.position"
            :md-duration="snackbar.duration"
            :md-active.sync="snackbar.visibleSnackbar"
            :md-persistent="false">
            <span>
                {{ snackbar.alertMessage }}
            </span>
            <md-button class="md-primary"
                @click="snackbar.visibleSnackbar = false">
                {{ $t('actions.dismiss') }}
            </md-button>
        </md-snackbar>

        <md-toolbar>
            <!-- Right buttons -->
            <div class="md-toolbar-section-end">
                <md-field md-clearable>
                    <md-input :placeholder="$t('general.search-by-description')"
                        v-model="search">
                    </md-input>
                </md-field>
                <md-button class="md-icon-button"
                    @click="fetchCategories">
                    <md-icon>refresh</md-icon>
                </md-button>
                <md-button class="md-icon-button"
                    @click="addCategory">
                    <md-icon>add_circle_outline</md-icon>
                </md-button>
            </div>
        </md-toolbar>

        <v-data-table :headers="headers"
            :items="dataSource"
            :pagination.sync="pagination"
            class="elevation-1">
            <template v-slot:items="props">
                <td class="text-xs-right">
                    {{ props.item.category_id }}
                </td>
                <td class="text-xs-left">
                    {{ props.item.category_name }}
                </td>
                <td class="text-xs-right">
                    {{ props.item.created_at }}
                </td>
                <td class="text-xs-right">
                    {{ props.item.deleted_at }}
                </td>
                <td class="justify-center px-0">
                    <md-button class="md-icon-button"
                        @click="editCategories(props.item)"
                        :disabled="!props.item.active">
                        <md-icon>edit</md-icon>
                        <md-tooltip md-direction="top">
                            {{ $t('actions.edit') }}
                        </md-tooltip>
                    </md-button>
                    <md-button class="md-icon-button"
                        @click="deleteCategories(props.item)">
                        <md-icon>delete</md-icon>
                        <md-tooltip md-direction="top">
                            {{ $t('actions.disable') }}
                        </md-tooltip>
                    </md-button>
                </td>
            </template>
        </v-data-table>
    </v-app>
</template>

<script>
import _ from 'lodash'
import categoriesService from '@/components/categories/services/'
import Swal from 'sweetalert2'

export default {
    name: 'Categories',

    components: {
    },

    data () {
        return {
            dataSource: [],

            search: '',

            snackbar: {
                visibleSnackbar: false,
                position: 'center',
                duration: 3000,
                alertMessage: this.$t('validations.operation-performed-successfully')
            },

            paginationAux: {
                descending: true,
                page: 1,
                rowsPerPage: 10,
                sortBy: 'category_name',
                totalItems: 0,
                rowsPerPageItems: [5, 10, 15, 25, 50]
            },

            headers: [
                { text: this.$t('general.id'), align: 'center', sortable: true, value: 'category_id' },
                { text: this.$t('categories.category-name'), align: 'left', value: 'category_name', sortable: true },
                { text: this.$t('general.created-at'), align: 'center', value: 'created_at', sortable: false },
                { text: this.$t('general.deleted-at'), align: 'center', value: 'deleted_at', sortable: false },
                { text: this.$tc('general.action', 2), align: 'center', sortable: false }
            ]
        }
    },
    computed: {
        pagination: {
            get: function () {
                return this.paginationAux
            },

            set: function (value) {
                this.paginationAux = value
                this.fetchCategories()
            }
        }
    },
    methods: {
        async fetchCategories () {
            let self = this

            self.dataSource = []

            let parameters = {
                pagination: {
                    itemsPerPage: self.paginationAux.rowsPerPage,
                    page: self.paginationAux.page
                },
                orderBy: {
                    column: self.paginationAux.sortBy,
                    direction: self.paginationAux.descending ? 'DESC' : 'ASC'
                }
            }

            let response = await categoriesService.getAll(parameters)
            self.dataSource = _.cloneDeep(response.data)
        },

        addCategory () {
            this.$router.push('/categories/new')
        },

        editCategories (item) {
            this.$router.push('/categories/' + item.category_id + '/edit')
        },

        deleteCategories (item) {
            Swal.fire({
                title: this.$t('validations.confirmation'),
                text: this.$t('validations.question-item-delete-confirm'),
                type: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonText: this.$t('actions.cancel'),
                confirmButtonText: this.$t('actions.confirm'),
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.confirmDelete(item)
                }
            })
        },

        async confirmDelete (item) {
            let self = this

            await categoriesService.delete(item.category_id)

            self.fetchCategories()
            self.showSnackbar()
        },

        showSnackbar () {
            this.snackbar.visibleSnackbar = true
        }
    },

    created () {
        this.fetchCategories()
    }
}
</script>
